import React from 'react';
import { FormControlLabel, FormGroup, Switch, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useField } from 'formik';

function FileField({ label, ...props }) {
    const [{ value, ...field }, meta, helpers] = useField(props);

    const handleChange = (event) => {
        const files = Array.from(event.target.files);
        const [file] = files;
        helpers.setValue(file);
    };

    return (
        <FormGroup
            sx={{
                pl: 0.5
            }}
        >
            <label htmlFor={label}>{label}</label>
            <input id={label} type="file" {...field} {...props} onChange={handleChange} />
            <Typography variant="caption">{meta.touched && !!meta.error ? meta.error : '  '} &nbsp;</Typography>
        </FormGroup>
    );
}

export default FileField;
